
const Contact = () =>{
    return(
        <div className="contact">
            <h1>Contact</h1>

            <form action="">

                <input type="text" id="name" placeholder="name"/>

                <textarea type="text" id="message" placeholder="message"/>

                <button>Submit</button>
            </form>

        </div>
    )
}

export default Contact